module.exports = __webpack_public_path__ + "img/mapna.e0df8e4.png";